"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSliderInit = allSliderInit;
// @ts-ignore
var splide_1 = require("@splidejs/splide");
// @ts-ignore
var splide_extension_auto_scroll_1 = require("@splidejs/splide-extension-auto-scroll");
// @ts-ignore
require("@splidejs/splide/dist/css/splide.min.css");
function allSliderInit() {
    logoSliderInit();
    linkedContentSliderInit();
}
// lcs = linked content slider 
function linkedContentSliderInit() {
    if (!isSliderOnSite('.linked-content-slider'))
        return;
    var lcsSplide = new splide_1.Splide('.linked-content-slider', {
        drag: true,
        focus: 'center',
        type: 'splide', // 
        pagination: false,
        arrows: true,
        rewind: true,
    }).mount();
    var index = lcsSplide.index;
    lcsAdjustSliderArrows(lcsSplide, index);
    // on slide change, set the position of the buttons 
    lcsSplide.on('moved', function (newIndex) {
        lcsAdjustSliderArrows(lcsSplide, newIndex);
    });
    window.addEventListener('resize', function () {
        var index = lcsSplide.index;
        lcsAdjustSliderArrows(lcsSplide, index);
    });
    lcsShowClickedCategoryEvent(lcsSplide);
}
function lcsAdjustSliderArrows(lcsSplide, newIndex) {
    // position the arrow buttons
    var slider = document.querySelector('.linked-content-slider');
    var sliderArrows = slider.querySelector('.splide__arrows');
    var currentSlide = slider.querySelector('.is-active');
    var image = currentSlide.querySelector('.splide__slide-image-container img');
    if (!image) {
        console.warn('Image not found in the current slide:', currentSlide);
        return;
    }
    var imageWidth = image.offsetWidth;
    var imageHeight = image.offsetHeight;
    sliderArrows.style.width = "".concat(imageWidth, "px");
    sliderArrows.style.height = "".concat(imageHeight, "px");
}
/**
 * Links Buttons to the slider and sets up an event listener for button clicks. And shows the clicked category.
 *
 * @param lcsSplide linked content slider instance
 */
function lcsShowClickedCategoryEvent(lcsSplide) {
    var buttonContainer = document.querySelector('.button-container');
    buttonContainer.addEventListener('click', function (event) {
        var target = event.target;
        if (target.classList.contains('is-category-button')) {
            var slideIndex = target.dataset.slideIndex;
            var slideIndexNumber = parseInt(slideIndex, 10);
            if (lcsSplide) {
                lcsSplide.go(slideIndexNumber);
            }
        }
    });
}
function loadLogoSliderContent() {
    var _a;
    var container = document.querySelector(".logo-slider-block");
    var allLogos = JSON.parse((_a = container.dataset.logos) !== null && _a !== void 0 ? _a : '[]');
    var isMobile = window.innerWidth <= 768;
    var groupCount = isMobile ? 3 : 2;
    var chunkSize = Math.ceil(allLogos.length / groupCount);
    var chunks = [];
    for (var i = 0; i < allLogos.length; i += chunkSize) {
        chunks.push(allLogos.slice(i, i + chunkSize));
    }
    // Slider-Container generieren
    chunks.forEach(function (group, index) {
        var splide = document.createElement("div");
        splide.className = "splide logo-slider-".concat(index + 1);
        splide.innerHTML = "\n      <div class=\"splide__track\" dir=\"ltr\">\n        <ul class=\"splide__list\">\n          ".concat(group.map(function (logo) { return "\n            <li class=\"splide__slide\">\n              <img src=\"".concat(logo.url, "\" alt=\"").concat(logo.alt, "\" />\n            </li>\n          "); }).join(''), "\n        </ul>\n      </div>\n    ");
        container.appendChild(splide);
    });
}
function logoSliderInit() {
    if (!isSliderOnSite('.logo-slider-block'))
        return;
    loadLogoSliderContent();
    new splide_1.Splide('.logo-slider-1', {
        //   type: 'loop',
        type: 'loop',
        drag: 'free',
        focus: 'center',
        pagination: false,
        arrows: false,
        perPage: 3,
        autoScroll: {
            speed: 0.45,
        },
    }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    if (isSliderOnSite('.logo-slider-2')) {
        new splide_1.Splide('.logo-slider-2', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            pagination: false,
            perPage: 3,
            arrows: false,
            autoScroll: {
                speed: 0.3,
            },
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
    if (isSliderOnSite('.logo-slider-3')) {
        new splide_1.Splide('.logo-slider-3', {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            pagination: false,
            perPage: 3,
            arrows: false,
            autoScroll: {
                speed: 0.37,
            },
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
    ;
}
function isSliderOnSite(selector) {
    return !!document.querySelector(selector);
}
